"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = unwrappedSignatureDetector;

var _domWalkers = _interopRequireDefault(require("./dom-walkers"));

var _escapeStringRegexp = _interopRequireDefault(require("escape-string-regexp"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function textAndNodesAfterNode(node) {
  var text = '';
  var curNode = node;
  var nodes = [];

  while (curNode) {
    var sibling = curNode.nextSibling;

    while (sibling) {
      text += sibling.textContent;
      nodes.push(sibling);
      sibling = sibling.nextSibling;
    }

    curNode = curNode.parentNode;
  }

  return {
    text: text,
    nodes: nodes
  };
}
/**
 * Sometimes the last signature of an email will not be placed in a quote
 * block. This will cause out quote detector to not strip anything since
 * it looks very similar to someone writing inline regular text after some
 * quoted text (which is allowed).
 *
 * See email_18, email_20, email_21, and email_23 test cases for this.
 */


function unwrappedSignatureDetector(doc, quoteElements) {
  // Find the last quoteBlock
  var _iterator = _createForOfIteratorHelper(_domWalkers["default"].walkBackwards(doc)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      var textAndNodes = void 0;
      var focusNode = node;

      if (node && quoteElements.includes(node)) {
        textAndNodes = textAndNodesAfterNode(node);
      } else if (node.previousSibling && quoteElements.includes(node.previousSibling)) {
        focusNode = node.previousSibling;
        textAndNodes = textAndNodesAfterNode(node.previousSibling);
      } else {
        continue;
      }

      var _textAndNodes = textAndNodes,
          text = _textAndNodes.text,
          nodes = _textAndNodes.nodes;
      var maybeSig = text.replace(/\s/g, '');

      if (maybeSig.length > 0) {
        if ((focusNode.textContent || '').replace(/\s/g, '').search((0, _escapeStringRegexp["default"])(maybeSig)) >= 0) {
          return nodes;
        }
      }

      break;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return [];
}
//# sourceMappingURL=unwrapped-signature-detector.js.map